import React from "react";
import Text from "./Text";
import List from "./List";

export default function Icons({ content, page }) {
  return (
    <div
      className={
        page === "overview-magic-remote"
          ? `${page} body-icons special-icons`
          : `${page} body-icons`
      }
      style={{
        display: "flex",
        flexDirection: content.flex.direction,
        justifyContent: content.flex.justify,
        alignItems: content.flex.align,
        margin: content.component_margin,
        height: content.full_height ? "100%" : "auto",
      }}
    >
      {content.content.map((item, i) => {
        return (
          <div
            key={`icons${i}`}
            style={
              content.flex.direction === "row"
                ? {
                    marginRight: content.spacing,
                    opacity: item.animation_delay ? "0" : "1",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    animation:
                      item.animation_delay &&
                      `0.3s ease ${item.animation_delay} 1 normal forwards running fadeInUp`,
                  }
                : {
                    marginLeft: item.custom_left ? item.custom_left : null,
                    marginBottom: content.spacing,
                    display: "flex",
                    opacity: item.animation_delay ? "0" : "1",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    animation:
                      item.animation_delay &&
                      `0.3s ease ${item.animation_delay} 1 normal forwards running fadeInUp`,
                  }
            }
          >
            <img
              height={item.custom_height ? item.custom_height : content.height}
              src={item.src}
              alt=""
              style={{ alignSelf: "flex-start" }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                height: item.custom_height
                  ? item.custom_height
                  : content.height,
                opacity: item.animation_delay ? "0" : "1",
                animation:
                  item.animation_delay &&
                  `0.3s ease ${item.animation_delay} 1 normal forwards running fadeInUp`,
              }}
            >
              {item.text && <Text content={item.text} />}
              {item.list && <List content={item.list} />}
            </div>
          </div>
        );
      })}
    </div>
  );
}
